// extracted by mini-css-extract-plugin
export default {"collapse":"FrequencyCollapsePanel_collapse__0F8FB"};